/*All Constants*/

import { urlsAuth, routesAuth } from './api_routes/auth';
import { urlsAttendance, routesAttendance } from './api_routes/attendance';
import { urlsCalendar, routesCalendar } from './api_routes/calendar.js';
import { urlsContent, routesContent } from './api_routes/cms_content.js';
import { urlsDissertations, routesDissertations } from './api_routes/dissertations';
import { urlsErasmus, routesErasmus } from './api_routes/erasmus';
import { urlsExternal, routesExternal } from './api_routes/external';
import { urlsFriEdu, routesFriEdu } from './api_routes/friEdu';
import { urlsFriInternalJobs, routesFriInternalJobs } from './api_routes/friInternalJobs.js';
import { urlsFriJobs, routesFriJobs } from './api_routes/friJobs';
import { urlsFriOpen, routesFriOpen } from './api_routes/friOpen';
import { urlsIngProjects, routesIngProjects } from './api_routes/ingProjects';
import { urlsMeteo, routesMeteo } from './api_routes/meteo';
import { urlsPolls, routesPolls } from './api_routes/polls.js';
import { urlsPortalManagement, routesPortalManagement } from './api_routes/portalManagement';
import { urlsRoomReservations, routesRoomReservations } from './api_routes/roomReservations.js';
import { urlsSearch, routesSearch } from './api_routes/search';
import { urlsStudyPrograms, routesStudyPrograms } from './api_routes/studyPrograms';
import { urlsYellowBooks, routesYellowBooks } from './api_routes/yellowBooks';
import { urlsFriVia, routesFriVia } from './api_routes/friVia';
import { urlsPhd, routesPhd } from './api_routes/phd';
import { urlsEvaluation, routesEvaluation } from './api_routes/evaluationFunctions.js';
import { urlsTranslation } from './api_routes/translations.js';
import { urlsWiki, routesWiki } from "./api_routes/wiki.js";

export { API_ENDPOINT, API_AUTH_ENDPOINT } from './api_routes/config';

export const urls = {
  ...urlsContent,
  ...urlsCalendar,
  ...urlsDissertations,
  ...urlsErasmus,
  ...urlsAttendance,
  ...urlsPortalManagement,
  ...urlsStudyPrograms,
  ...urlsRoomReservations,
  ...urlsFriOpen,
  ...urlsExternal,
  ...urlsFriJobs,
  ...urlsYellowBooks,
  ...urlsIngProjects,
  ...urlsMeteo,
  ...urlsPolls,
  ...urlsSearch,
  ...urlsFriEdu,
  ...urlsFriInternalJobs,
  ...urlsAuth,
  ...urlsFriVia,
  ...urlsPhd,
  ...urlsEvaluation,
  ...urlsTranslation,
  ...urlsWiki,
};

export const routes = {
  ...routesAuth,
  ...routesCalendar,
  ...routesContent,
  ...routesDissertations,
  ...routesFriEdu,
  ...routesErasmus,
  ...routesRoomReservations,
  ...routesFriOpen,
  ...routesYellowBooks,
  ...routesMeteo,
  ...routesAttendance,
  ...routesExternal,
  ...routesFriJobs,
  ...routesFriInternalJobs,
  ...routesIngProjects,
  ...routesPortalManagement,
  ...routesPolls,
  ...routesSearch,
  ...routesFriVia,
  ...routesPhd,
  ...routesEvaluation,
  ...routesStudyPrograms,
  ...routesWiki
};

export default class ApiClient {
  static getAuthFormData(token) {
    let authData = new FormData();
    authData.append('token', token);
    return authData;
  }
}
